import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Label,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import moment from "moment";
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear(),
    years = [];
  startYear = 1945;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

var reformatOptions = (raw, label, value) => {
  return raw.map(function (data) {
    var newObj = {};
    if (data["position_grade"] != null && data["position_grade"] > 0) {
      newObj["label"] = data[label] + " (Grade " + data["position_grade"] + ")";
    } else {
      newObj["label"] = data[label];
    }

    newObj["value"] = data[value];
    newObj["model"] = data;
    console.log(newObj);
    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();
  defaultSize = 10;
  // Retrieve Data Pegawai by Admin / Pegawai
  userdata = JSON.parse(localStorage.getItem("userdata"));
  employeeSeleted = JSON.parse(localStorage.getItem("employeeSelected"));
  peg_uuid = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_uuid
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_uuid
    : "";
  peg_nip = !accessRole("approve")
    ? this.userdata != null
      ? this.userdata.employee_nip
      : ""
    : this.employeeSeleted != null
    ? this.employeeSeleted.employee_nip
    : "";

  queryParams = new URLSearchParams(window.location.search);

  constructor(props) {
    super(props);
    this.state = {
      educationOptions: [],
      rumpunOptions: [],
      yearOptions: createYearOption(new Date().getFullYear() - 30),
      type: null,
      position_type: 1,
      positionFilter: {
        filter_value: "",
        page_number: 1,
        page_size: 9999,
        sort_order: {
          column: "position_id",
          order: "asc",
        },
      },
      jabatanOption: [],
      typeriwayat: this.queryParams.get("type"),
      education_code: "",
      employeeOption: [],
    };
  }

  reformatEducationOptions = (raw) => {
    return raw.map((data) => {
      return {
        label: `${data.education_kemenkeu_code ?? "-"} - ${
          data.education_name
        }`,
        value: data.education_uuid,
        code: data.education_kemenkeu_code,
        model: data,
      };
    });
  };

  reformatOptions = (raw, label, value) => {
    return raw.map(function (data) {
      var newObj = {};
      newObj["label"] = data[label];
      newObj["value"] = data[value];
      return newObj;
    });
  };

  getType = () => {
    let type = this.queryParams.get("type");

    if (type == "riwayat") {
      return "Riwayat Pendidikan";
    } else if (type == "gelar") {
      return "Pencantuman Gelar";
    } else {
      return "Riwayat Pendidikan";
    }
  };

  dateParse = (input) => {
    let res = "";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, [
      "file_ijazah",
      "file_akre",
      "file_penyetaraan",
      "sk_tubel",
      "surat_izin_belajar",
      "surat_kronologi",
      "nota_dinas",
      "sk_pangkat",
    ]); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        education_background_employee_uuid: this.peg_uuid,
      },
      confirm: true,
    });
  };
  loadPosition = async (uuid) => {
    let offset =
      (this.state.positionFilter.page_number - 1) *
      this.state.positionFilter.page_size;
    const query = {
      uuid: uuid,
      search: this.state.positionFilter.filter_value,
      limit: this.state.positionFilter.page_size,
      offset: offset,
      order: this.state.positionFilter.sort_order.column,
      sort: this.state.positionFilter.sort_order.order,
      status: 1,
      position_type: this.state.position_type,
    };
    this.setState({ loadingPosition: true });
    await this.createBloc.fetchListJabatan(query);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.loadPosition("");
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.educationChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              educationOptions: this.reformatEducationOptions(
                response.result,
                "education_name",
                "education_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.rumpunChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              rumpunOptions: this.reformatOptions(
                response.result,
                "education_group_name",
                "education_group_uuid"
              ),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    let type = this.queryParams.get("type");
    this.createBloc.fetchEducation({
      is_college: type == "gelar" ? 1 : 2,
    });
    this.createBloc.fetchRumpun({
      is_college: type == "gelar" ? 1 : 2,
    });

    this.createBloc.listJabatanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            positionOption: result.data.response.result,
            loadingPosition: false,
          });
          this.setState({
            jabatanOption: reformatOptions(
              result.data.response.result,
              "position_name",
              "position_uuid"
            ),
          });

          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          const employeeData = result?.data?.response?.data?.decryptData?.[0];

          this.setState({
            employeeOption: employeeData || {},
            loadingEmployee: false,
          });

          break;

        case apiResponse.ERROR:
          console.error("Employee Categories error:", result);
          this.setState({
            loadingEmployee: false,
          });
          break;

        default:
          break;
      }
    });
    this.createBloc.fetchEmployee({
      nip: this.peg_nip,
    });
  }

  componentWillUnmount() {
    this.createBloc.createChannel.unsubscribe();
    this.createBloc.educationChannel.unsubscribe();
    this.createBloc.rumpunChannel.unsubscribe();
    this.createBloc.employeeChannel.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="riwayat_pendidikan" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <CardTitle>Tambah {this.getType()}</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    {this.state.typeriwayat == "gelar" ? (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Jenis Pencantuman Gelar{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="4">
                          <Select
                            id="employee_transfer_detail_type"
                            options={[
                              { value: 1, label: "Tugas Belajar" },
                              { value: 2, label: "Izin Belajar" },
                              {
                                value: 3,
                                label: "Telah Memiliki sebelum CPNS",
                              },
                            ]}
                            onChange={(opt) =>
                              this.setState({ type: opt.value })
                            }
                            // defaultValue={detailMutasi?.employee_transfer_detail_type}
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                        <AvField
                          name="employee_transfer_detail_type"
                          type="hidden"
                          value={this.state.type}
                        />
                      </Row>
                    ) : (
                      ""
                    )}
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        {/* Jenjang <span className="text-danger">*</span> */}
                        Tingkat Pendidikan{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="education_background_education_uuid"
                          errorMessage="Pilih Tingkat Pendidikan"
                          options={this.state.educationOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Tingkat Pendidikan"
                          onChange={(opt) =>
                            this.setState((prev) => ({
                              dataForm: {
                                ...prev.dataForm,
                                education_background_education_uuid:
                                  opt?.value || "",
                                education_code: opt?.code || "", // 🔥 ini yang kamu mau
                              },
                            }))
                          }
                        />
                        <AvField
                          type="hidden"
                          name="education_code"
                          value={this.state.dataForm?.education_code || ""}
                        />
                      </Col>
                    </Row>
                    {this.state.typeriwayat == "gelar" ? (
                      <>
                        <Row className="mb-3">
                          {/* <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                                >
                                                Rumpun
                                            </label> */}
                          <label
                            htmlFor="no_sk"
                            className="col-md-3 col-form-label"
                          >
                            Rumpun &nbsp;<span className="text-danger">*</span>
                          </label>
                          <Col md="4">
                            <CustomSelect
                              name="education_background_education_group_uuid"
                              errorMessage="Pilih Pendidikan"
                              options={this.state.rumpunOptions}
                              placeholder="Pilih Pendidikan"
                              validate={{ required: { value: true } }}
                              // defaultValue={this.state.dataForm.education_background_education_uuid}
                            />
                          </Col>
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row className="mb-3">
                          <label
                            htmlFor="no_sk"
                            className="col-md-3 col-form-label"
                          >
                            Rumpun &nbsp;
                          </label>
                          <Col md="4">
                            <CustomSelect
                              name="education_background_education_group_uuid"
                              errorMessage="Pilih Pendidikan"
                              options={this.state.rumpunOptions}
                              placeholder="Pilih Pendidikan"
                            />
                          </Col>
                        </Row>
                      </>
                    )}
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Dikeluarkan Ijazah{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="education_background_certificate_date"
                          id="education_background_certificate_date"
                          placeholder="Tanggal Ijazah"
                          type="date"
                          errorMessage="Masukan Tanggal Ijazah"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tahun Lulus <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <CustomSelect
                          name="education_background_graduation_year"
                          errorMessage="Pilih Tahun Lulus"
                          options={this.state.yearOptions}
                          validate={{ required: { value: true } }}
                          placeholder="Pilih Tahun Lulus"
                          defaultValue={new Date().getFullYear()}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor Ijazah <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="education_background_certificate_number"
                          id="education_background_certificate_number"
                          placeholder="Nomor Ijazah"
                          type="text"
                          errorMessage="Masukan Nomor Ijazah"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nama Sekolah / Perguruan Tinggi{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <AvField
                          name="education_background_school_name"
                          id="education_background_school_name"
                          placeholder="Nama Sekolah / Perguruan Tinggi"
                          type="text"
                          errorMessage="Masukan Nama Sekolah / Perguruan Tinggi"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    {this.state.typeriwayat == "riwayat" ? (
                      <Row className="mb-3">
                        <label
                          htmlFor="no_sk"
                          className="col-md-3 col-form-label"
                        >
                          Alamat Sekolah / Perguruan Tinggi{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="9">
                          <AvField
                            name="education_background_school_address"
                            id="education_background_school_address"
                            placeholder="Alamat Sekolah / Perguruan Tinggi"
                            type="text"
                            errorMessage="Masukan Alamat Sekolah / Perguruan Tinggi"
                            className="form-control"
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jurusan <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <AvField
                          name="education_background_school_major"
                          id="education_background_school_major"
                          placeholder="Jurusan"
                          type="text"
                          errorMessage="Masukan Jurusan"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Gelar Depan
                      </label>
                      <Col md="4">
                        <AvField
                          name="education_background_front_title"
                          id="education_background_front_title"
                          placeholder="Gelar Depan"
                          type="text"
                          errorMessage="Masukan Gelar Depan"
                          className="form-control"
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Gelar Belakang
                      </label>
                      <Col md="4">
                        <AvField
                          name="education_background_end_title"
                          id="education_background_end_title"
                          placeholder="Gelar Belakang"
                          type="text"
                          errorMessage="Masukan Gelar Belakang"
                          className="form-control"
                        />
                      </Col>
                    </Row>
                    {this.state.typeriwayat == "gelar" ? (
                      <Row className="mb-3">
                        <label
                          htmlFor="no_sk"
                          className="col-md-3 col-form-label"
                        >
                          Jabatan Yang Membidangi{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Col md="4">
                          <CustomSelect
                            name="education_background_parent_position_uuid"
                            options={this.state.jabatanOption}
                            //optionLabel="position_name"
                            //optionValue="position_uuid"
                            errorMessage="Pilih Jabatan Yang Membidangi"
                            // defaultValue={detailMutasi?.education_background_parent_position_uuid}
                            isLoading={this.state.loadingPosition}
                            validate={{ required: { value: true } }}
                          />
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Lokasi Dikeluarkanya Ijazah{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        <AvField
                          name="education_background_ijazah_location"
                          id="education_background_ijazah_location"
                          placeholder="Lokasi Dikeluarkannya Ijazah"
                          type="text"
                          errorMessage="Masukan Lokasi Dikeluarkannya Ijazah"
                          className="form-control"
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                    </Row>

                    {/* <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">Upload File Pendukung</Label>
                                            <Col md="8">
                                                <FileInput
                                                    name="file"
                                                    col="6"
                                                />
                                            </Col>
                                        </Row> */}

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Ijazah & Transkrip Nilai{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_ijazah"
                          validate={{ required: { value: true } }}
                          col="6"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Akreditasi Program Studi{" "}
                        <span className="text-danger">*</span>
                      </Label>
                      <Col md="6">
                        <FileInput
                          name="file_akre"
                          validate={{ required: { value: true } }}
                          col="6"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File Penyetaraan Ijazah Bagi Lulusan Luar Negeri
                      </Label>
                      <Col md="6">
                        <FileInput name="file_penyetaraan" col="6" />
                      </Col>
                    </Row>
                    {this.state.type == 1 &&
                    this.state.typeriwayat == "gelar" ? (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          SK Tugas Belajar{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="6">
                          <FileInput
                            name="sk_tubel"
                            validate={{ required: { value: true } }}
                            col="6"
                          />
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}

                    {this.state.type == 2 &&
                    this.state.typeriwayat == "gelar" ? (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Surat Izin Belajar{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Col md="6">
                          <FileInput
                            name="surat_izin_belajar"
                            validate={{ required: { value: true } }}
                            col="6"
                          />
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {this.state.type == 3 &&
                    this.state.typeriwayat == "gelar" ? (
                      <Row className="mb-3">
                        <Label className="col-md-3 col-form-label">
                          Surat Kronologi
                        </Label>
                        <Col md="6">
                          <FileInput name="surat_kronologi" col="6" />
                        </Col>
                      </Row>
                    ) : (
                      ""
                    )}
                    {this.state.typeriwayat == "gelar" ? (
                      <>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            Nota Dinas <span className="text-danger">*</span>
                          </Label>
                          <Col md="6">
                            <FileInput
                              name="nota_dinas"
                              validate={{ required: { value: true } }}
                              col="6"
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Label className="col-md-3 col-form-label">
                            SK Pangkat Terakhir{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Col md="6">
                            <FileInput
                              name="sk_pangkat"
                              validate={{ required: { value: true } }}
                              col="6"
                            />
                          </Col>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                    {/* <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Depan 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_front_title"
                                                    id="education_background_front_title"
                                                    placeholder="Gelar Depan"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Depan"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                />
                                            </Col>
                                        </Row>    

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Gelar Belakang 
                                            </label>
                                            <Col md="2">
                                                 <AvField
                                                    name="education_background_end_title"
                                                    id="education_background_end_title"
                                                    placeholder="Gelar Belakang"
                                                    type="text"
                                                    errorMessage="Masukan Gelar Belakang"
                                                    className="form-control"
                                                    validate={{ required: { value: false } }}
                                                />
                                            </Col>
                                        </Row> */}

                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to="/kepegawaian/home.html?riwayat_pendidikan">
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <AvField
                        type="hidden"
                        name="employee_satker_code"
                        value={this.state.employeeOption?.kdsatker}
                      />
                      <AvField
                        type="hidden"
                        name="employee_nip"
                        value={this.state.employeeOption?.nip}
                      />
                      <AvField
                        type="hidden"
                        name="employee_name"
                        value={this.state.employeeOption?.nmpeg}
                      />
                      <AvField
                        type="hidden"
                        name="employee_place_of_birth_city_text"
                        value={this.state.employeeOption?.tempatlhr}
                      />
                      <AvField
                        type="hidden"
                        name="employee_date_of_birth"
                        value={this.state.employeeOption?.tgllhr}
                      />
                      <AvField
                        type="hidden"
                        name="employee_religion_kode_kemenkeu"
                        value={this.state.employeeOption?.kdagama}
                      />
                      <AvField
                        type="hidden"
                        name="employee_gender"
                        value={this.state.employeeOption?.kdkelamin}
                      />
                      <AvField
                        type="hidden"
                        name="employee_domicile_address"
                        value={this.state.employeeOption?.alamat}
                      />
                      <AvField
                        type="hidden"
                        name="employee_npwp_number"
                        value={this.state.employeeOption?.npwp}
                      />
                      <AvField
                        type="hidden"
                        name="employee_bank_name"
                        value={this.state.employeeOption?.nm_bank}
                      />
                      <AvField
                        type="hidden"
                        name="employee_bank_account_number"
                        value={this.state.employeeOption?.rekening}
                      />
                      <AvField
                        type="hidden"
                        name="employee_bank_account_name"
                        value={this.state.employeeOption?.nmrek}
                      />
                      <AvField
                        type="hidden"
                        name="employee_domicile_postal_code"
                        value={this.state.employeeOption?.kdpos}
                      />
                      <AvField
                        type="hidden"
                        name="employee_categories_kode_kemenkeu"
                        value={this.state.employeeOption?.jpns}
                      />
                      <AvField
                        type="hidden"
                        name="employee_identity_number"
                        value={this.state.employeeOption?.nik}
                      />
                      <AvField
                        type="hidden"
                        name="employee_family_card_number"
                        value={this.state.employeeOption?.nokk}
                      />
                      <AvField
                        type="hidden"
                        name="employee_bankspan_code"
                        value={this.state.employeeOption?.kdbankspan}
                      />
                      <AvField
                        type="hidden"
                        name="employee_honorer"
                        value={this.state.employeeOption?.honorer}
                      />
                      <AvField
                        type="hidden"
                        name="employee_email_internal"
                        value={this.state.employeeOption?.email}
                      />
                      <AvField
                        type="hidden"
                        name="employee_mobile_phone_number"
                        value={this.state.employeeOption?.notelp}
                      />
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/home.html?riwayat_pendidikan" />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
